import { onScopeDispose, watch } from 'vue'

/**
 * Locks scrolling on the document while an overlay is open.
 *
 * All page shells scroll the document (AppLayout and DashboardLayout both use
 * min-h-screen), so an open modal would otherwise let the page scroll behind it.
 * A shared counter keeps stacked modals from unlocking each other, and the
 * scrollbar width is compensated so locking does not shift the layout.
 */
let lockCount = 0
let previousOverflow = ''
let previousPaddingRight = ''

function lockDocument() {
  if (lockCount === 0) {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

    previousOverflow = document.body.style.overflow
    previousPaddingRight = document.body.style.paddingRight

    document.body.style.overflow = 'hidden'

    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`
    }
  }

  lockCount++
}

function unlockDocument() {
  if (lockCount === 0) {
    return
  }

  lockCount--

  if (lockCount === 0) {
    document.body.style.overflow = previousOverflow
    document.body.style.paddingRight = previousPaddingRight
  }
}

export function useScrollLock(isOpen) {
  let locked = false

  const sync = (open) => {
    if (open && !locked) {
      lockDocument()
      locked = true
      return
    }

    if (!open && locked) {
      unlockDocument()
      locked = false
    }
  }

  watch(isOpen, sync, { immediate: true })
  onScopeDispose(() => sync(false))
}
